// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1TuAi","field":"styles_field__2sx3T","fieldCol":"styles_fieldCol__3Hd4V","diffCol":"styles_diffCol__S-4Zs","diff":"styles_diff__1ANVf"};